import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-lg-3 col-md-6 mb-4">
          <div className="text-center">
            <Link to="/zakat">
              <img
                className="rounded-circle mx-auto d-block mb-3"
                src="/assets/img/zakat2.jpg"
                alt="Zakat"
                width="140"
                height="140"
              />
            </Link>
            <h3>What is Zakat</h3>
            <p>
              Zakat is one of the 5 pillars of Islam and an important obligation upon all Muslims who meet the criteria of Nisab.
            </p>
            <Link className="btn btn-success" to="/zakat">
              View details »
            </Link>
          </div>
        </div>

        <div className="col-lg-3 col-md-6 mb-4">
          <div className="text-center">
            <Link to="/nisab">
              <img
                className="rounded-circle mx-auto d-block mb-3"
                src="/assets/img/nisab3.jpg"
                alt="Nisab"
                width="140"
                height="140"
              />
            </Link>
            <h3>What is Nisab</h3>
            <p>
              Nisab is the minimum amount that a Muslim must have before they have to give Zakah.
            </p>
            <Link className="btn btn-success" to="/nisab">
              View details »
            </Link>
          </div>
        </div>

        <div className="col-lg-3 col-md-6 mb-4">
          <div className="text-center">
            <Link to="/zakat">
              <img
                className="rounded-circle mx-auto d-block mb-3"
                src="/assets/img/zakat4.jpg"
                alt="When Zakat is owed"
                width="140"
                height="140"
              />
            </Link>
            <h3>When is Zakat owed</h3>
            <p>
              When your total assets reach or go beyond Nisab on a given day, zakat is owed one lunar year from that day.
            </p>
            <Link className="btn btn-success" to="/zakat">
              View details »
            </Link>
          </div>
        </div>

        <div className="col-lg-3 col-md-6 mb-4">
          <div className="text-center">
            <a href="https://www.islamanswers.co.uk/zakat-fund">
              <img
                className="rounded-circle mx-auto d-block mb-3"
                src="/assets/img/payzakat.jpg"
                alt="Pay Zakat"
                width="140"
                height="140"
              />
            </a>
            <h3>Pay your Zakat</h3>
            <p>
              Islam Answers provides a service for collecting and distributing zakat on a 100% donation policy.
            </p>
            <a className="btn btn-success" href="https://www.islamanswers.co.uk/zakat-fund">
              Pay Zakat »
            </a>
          </div>
        </div>
      </div>

      <div className="alert alert-warning mt-4">
        <strong>Please make sure you have studied the Fiqh of Zakat.</strong> Without having studied Fiqh of Zakat, you may make mistakes in calculating Zakat.
      </div>
    </div>
  );
};

export default Home;
